module.exports = __webpack_public_path__ + "img/squall.f4d62908.jpg";